import React from "react";

export const schema = {
        title: "",
        description: "",
        type: "object",
        //required: ["title"],
        properties: {
            right_1st_toe_flexion: {type: "integer", title: "", default: ""},
            left_1st_toe_flexion: {type: "integer", title: "", default: ""},

            right_1st_toe_extension: {type: "integer", title: "", default: ""},
            left_1st_toe_extension: {type: "integer", title: "", default: ""},

            right_ankle_dorsiflexion: {type: "integer", title: "", default: ""},
            left_ankle_dorsiflexion: {type: "integer", title: "", default: ""},

            right_ankle_plantarflexion: {type: "integer", title: "", default: ""},
            left_ankle_plantarflexion: {type: "integer", title: "", default: ""},

            right_ankle_eversion: {type: "integer", title: "", default: ""},
            left_ankle_eversion: {type: "integer", title: "", default: ""},

            right_ankle_inversion: {type: "integer", title: "", default: ""},
            left_ankle_inversion: {type: "integer", title: "", default: ""},

            right_knee_extension: {type: "integer", title: "", default: ""},
            left_knee_extension: {type: "integer", title: "", default: ""},

            right_knee_flexion: {type: "integer", title: "", default: ""},
            left_knee_flexion: {type: "integer", title: "", default: ""},

            right_hip_extension: {type: "integer", title: "", default: ""},
            left_hip_extension: {type: "integer", title: "", default: ""},

            right_hip_flexion: {type: "integer", title: "", default: ""},
            left_hip_flexion: {type: "integer", title: "", default: ""},

            right_hip_abduction: {type: "integer", title: "", default: ""},
            left_hip_abduction: {type: "integer", title: "", default: ""},

            right_hip_adduction: {type: "integer", title: "", default: ""},
            left_hip_adduction: {type: "integer", title: "", default: ""},            
            left_hip_internal_rotation: {type: "integer", title: "", default: ""},
            right_hip_internal_rotation: {type: "integer", title: "", default: ""},
            left_hip_external_rotation: {type: "integer", title: "", default: ""},
            right_hip_external_rotation: {type: "integer", title: "", default: ""},

            right_glenohumeral_flexion: {type: "integer", title: "", default: ""},
            left_glenohumeral_flexion: {type: "integer", title: "", default: ""},

            right_glenohumeral_extension: {type: "integer", title: "", default: ""},
            left_glenohumeral_extension: {type: "integer", title: "", default: ""},

            right_glenohumeral_abduction: {type: "integer", title: "", default: ""},
            left_glenohumeral_abduction: {type: "integer", title: "", default: ""},

            right_glenohumeral_internal_rotation: {type: "integer", title: "", default: ""},
            left_glenohumeral_internal_rotation: {type: "integer", title: "", default: ""},

            right_glenohumeral_external_rotation: {type: "integer", title: "", default: ""},
            left_glenohumeral_external_rotation: {type: "integer", title: "", default: ""},

            right_elbow_flexion: {type: "integer", title: "", default: ""},
            left_elbow_flexion: {type: "integer", title: "", default: ""},

            right_elbow_extension: {type: "integer", title: "", default: ""},
            left_elbow_extension: {type: "integer", title: "", default: ""},

            right_wrist_flexion: {type: "integer", title: "", default: ""},
            left_wrist_flexion: {type: "integer", title: "", default: ""},

            right_wrist_extension: {type: "integer", title: "", default: ""},
            left_wrist_extension: {type: "integer", title: "", default: ""},

            right_wrist_radial_deviation: {type: "integer", title: "", default: ""},
            left_wrist_radial_deviation: {type: "integer", title: "", default: ""},

            right_wrist_ulnar_deviation: {type: "integer", title: "", default: ""},
            left_wrist_ulnar_deviation: {type: "integer", title: "", default: ""},

            right_thumb_flexion: {type: "integer", title: "", default: ""},
            left_thumb_flexion: {type: "integer", title: "", default: ""},

            right_thumb_extension: {type: "integer", title: "", default: ""},
            left_thumb_extension: {type: "integer", title: "", default: ""},

            right_thumb_abduction: {type: "integer", title: "", default: ""},
            left_thumb_abduction: {type: "integer", title: "", default: ""},

            right_thumb_adduction: {type: "integer", title: "", default: ""},
            left_thumb_adduction: {type: "integer", title: "", default: ""},

        }
}

export const uiSchema = {
    right_1st_toe_flexion: {
        "ui:widget": "updown",
        "ui:title": "Right - 1st Toe Flexion",
        "classNames": "heart-total-chol-ratio",
        "ui:description": "Flexion = 35-45°",
        "ui:placeholder": "0"
    },
    right_1st_toe_extension: {
        "ui:widget": "updown",
        "ui:title": "Right - 1st Toe Extension",
        "classNames": "heart-total-chol-ratio",
        "ui:description": "Extension = 75-85°",
        "ui:placeholder": "0"
    },
    right_ankle_dorsiflexion: {
        "ui:widget": "updown",
        "ui:title": "Right - Ankle Dorsiflexion",
        "classNames": "heart-total-chol-ratio",
        "ui:description": "Dorsiflexion = 20°",
        "ui:placeholder": "0"
    },
    right_ankle_plantarflexion: {
        "ui:widget": "updown",
        "ui:title": "Right - Ankle Plantarflexion",
        "classNames": "heart-total-chol-ratio",
        "ui:description": "Plantarflexion = 50°",
        "ui:placeholder": "0"
    },
    right_ankle_eversion: {
        "ui:widget": "updown",
        "ui:title": "Right - Ankle Eversion",
        "classNames": "heart-total-chol-ratio",
        "ui:description": "Eversion = 5°",
        "ui:placeholder": "0"
    },
    right_ankle_inversion: {
        "ui:widget": "updown",
        "ui:title": "Right - Ankle Inversion",
        "classNames": "heart-total-chol-ratio",
        "ui:description": "Inversion = 20°",
        "ui:placeholder": "0"
    },
    right_knee_extension: {
        "ui:widget": "updown",
        "ui:title": "Right - Knee Extension",
        "classNames": "heart-total-chol-ratio",
        "ui:description": "Extension = -10 to 0°",
        "ui:placeholder": "0"
    },
    right_knee_flexion: {
        "ui:widget": "updown",
        "ui:title": "Right - Knee Flexion",
        "classNames": "heart-total-chol-ratio",
        "ui:description": "Flexion = 135-145°",
        "ui:placeholder": "0"
    },
    right_hip_extension: {
        "ui:widget": "updown",
        "ui:title": "Right - Hip Extension",
        "classNames": "heart-total-chol-ratio",
        "ui:description": "Extension = 10-20°",
        "ui:placeholder": "0"
    },
    right_hip_flexion: {
        "ui:widget": "updown",
        "ui:title": "Right - Hip Flexion",
        "classNames": "heart-total-chol-ratio",
        "ui:description": "Hip flexion = 120 -130°",
        "ui:placeholder": "0"
    },
    right_hip_abduction: {
        "ui:widget": "updown",
        "ui:title": "Right - Hip Abduction",
        "classNames": "heart-total-chol-ratio",
        "ui:description": "Abduction = 45°",
        "ui:placeholder": "0"
    },
    right_hip_adduction: {
        "ui:widget": "updown",
        "ui:title": "Right - Hip Adduction",
        "classNames": "heart-total-chol-ratio",
        "ui:description": "Adduction = 30°",
        "ui:placeholder": "0"
    },

    left_hip_internal_rotation: {
        "ui:widget": "updown",
        "ui:title": "Left - Hip Internal Rotation",
        "classNames": "heart-total-chol-ratio",
        "ui:description": "Rotation = 30-45°",
        "ui:placeholder": "0"
    },
    right_hip_internal_rotation: {
        "ui:widget": "updown",
        "ui:title": "Right - Hip Internal Rotation",
        "classNames": "heart-total-chol-ratio",
        "ui:description": "Rotation = 30-45°",
        "ui:placeholder": "0"
    },
    left_hip_external_rotation: {
        "ui:widget": "updown",
        "ui:title": "Left - Hip External Rotation",
        "classNames": "heart-total-chol-ratio",
        "ui:description": "Rotation = 40-60°",
        "ui:placeholder": "0"
    },
    right_hip_external_rotation: {
        "ui:widget": "updown",
        "ui:title": "Right - Hip External Rotation",
        "classNames": "heart-total-chol-ratio",
        "ui:description": "Rotation = 40-60°",
        "ui:placeholder": "0"
    },
    right_glenohumeral_flexion: {
        "ui:widget": "updown",
        "ui:title": "Right - Glenohumeral Flexion",
        "classNames": "heart-total-chol-ratio",
        "ui:description": "Flexion = 170-180°",
        "ui:placeholder": "0"
    },
    right_glenohumeral_extension: {
        "ui:widget": "updown",
        "ui:title": "Right - Glenohumeral Extension",
        "classNames": "heart-total-chol-ratio",
        "ui:description": "Extension = 50 -60°",
        "ui:placeholder": "0"
    },
    right_glenohumeral_abduction: {
        "ui:widget": "updown",
        "ui:title": "Right - Glenohumeral Abduction",
        "classNames": "heart-total-chol-ratio",
        "ui:description": "Abduction = 170-180°",
        "ui:placeholder": "0"
    },
    right_glenohumeral_internal_rotation: {
        "ui:widget": "updown",
        "ui:title": "Right - Glenohumeral Internal Rotation",
        "classNames": "heart-total-chol-ratio",
        "ui:description": "Internal rotation = 80-90°",
        "ui:placeholder": "0"
    },
    right_glenohumeral_external_rotation: {
        "ui:widget": "updown",
        "ui:title": "Right - Glenohumeral External Rotation",
        "classNames": "heart-total-chol-ratio",
        "ui:description": "External rotation = 90-100°",
        "ui:placeholder": "0"
    },
    right_elbow_flexion: {
        "ui:widget": "updown",
        "ui:title": "Right - Elbow Flexion",
        "classNames": "heart-total-chol-ratio",
        "ui:description": "Flexion = 145-155°",
        "ui:placeholder": "0"
    },
    right_elbow_extension: {
        "ui:widget": "updown",
        "ui:title": "Right - Elbow Extension",
        "classNames": "heart-total-chol-ratio",
        "ui:description": "Extension = 0°",
        "ui:placeholder": "0"
    },
    right_wrist_flexion: {
        "ui:widget": "updown",
        "ui:title": "Right - Wrist Flexion",
        "classNames": "heart-total-chol-ratio",
        "ui:description": "Flexion = 80-90°",
        "ui:placeholder": "0"
    },
    right_wrist_extension: {
        "ui:widget": "updown",
        "ui:title": "Right - Wrist Extension",
        "classNames": "heart-total-chol-ratio",
        "ui:description": "Extension = 75-85°",
        "ui:placeholder": "0"
    },
    right_wrist_radial_deviation: {
        "ui:widget": "updown",
        "ui:title": "Right - Wrist Radial Deviation",
        "classNames": "heart-total-chol-ratio",
        "ui:description": "Radial deviation = 20°",
        "ui:placeholder": "0"
    },
    right_wrist_ulnar_deviation: {
        "ui:widget": "updown",
        "ui:title": "Right - Wrist Ulnar Deviation",
        "classNames": "heart-total-chol-ratio",
        "ui:description": "Ulnar deviation = 35°",
        "ui:placeholder": "0"
    },
    right_thumb_flexion: {
        "ui:widget": "updown",
        "ui:title": "Right - Thumb Flexion",
        "classNames": "heart-total-chol-ratio",
        "ui:description": "Flexion = 60-70°",
        "ui:placeholder": "0"
    },
    right_thumb_extension: {
        "ui:widget": "updown",
        "ui:title": "Right - Thumb Extension",
        "classNames": "heart-total-chol-ratio",
        "ui:description": "Extension = Only a trace amount of true CMC extension is permitted",
        "ui:placeholder": "0"
    },
    right_thumb_abduction: {
        "ui:widget": "updown",
        "ui:title": "Right - Thumb Abduction",
        "classNames": "heart-total-chol-ratio",
        "ui:description": "Abduction = 70-80°",
        "ui:placeholder": "0"
    },
    right_thumb_adduction: {
        "ui:widget": "updown",
        "ui:title": "Right - Thumb Adduction",
        "classNames": "heart-total-chol-ratio",
        "ui:description": "Adduction = True adduction is limited by the phalanx hitting the second metacarpal",
        "ui:placeholder": "0"
    },



    left_1st_toe_flexion: {
        "ui:widget": "updown",
        "ui:title": "Left - 1st Toe Flexion",
        "classNames": "heart-total-chol-ratio",
        "ui:description": "Flexion = 35-45°",
        "ui:placeholder": "0"
    },
    left_1st_toe_extension: {
        "ui:widget": "updown",
        "ui:title": "Left - 1st Toe Extension",
        "classNames": "heart-total-chol-ratio",
        "ui:description": "Extension = 75-85°",
        "ui:placeholder": "0"
    },
    left_ankle_dorsiflexion: {
        "ui:widget": "updown",
        "ui:title": "Left - Ankle Dorsiflexion",
        "classNames": "heart-total-chol-ratio",
        "ui:description": "Dorsiflexion = 20°",
        "ui:placeholder": "0"
    },
    left_ankle_plantarflexion: {
        "ui:widget": "updown",
        "ui:title": "Left - Ankle Plantarflexion",
        "classNames": "heart-total-chol-ratio",
        "ui:description": "Plantarflexion = 50°",
        "ui:placeholder": "0"
    },
    left_ankle_eversion: {
        "ui:widget": "updown",
        "ui:title": "Left - Ankle Eversion",
        "classNames": "heart-total-chol-ratio",
        "ui:description": "Eversion = 5°",
        "ui:placeholder": "0"
    },
    left_ankle_inversion: {
        "ui:widget": "updown",
        "ui:title": "Left - Ankle Inversion",
        "classNames": "heart-total-chol-ratio",
        "ui:description": "Inversion = 20°",
        "ui:placeholder": "0"
    },
    left_knee_extension: {
        "ui:widget": "updown",
        "ui:title": "Left - Knee Extension",
        "classNames": "heart-total-chol-ratio",
        "ui:description": "Extension = -10 to 0°",
        "ui:placeholder": "0"
    },
    left_knee_flexion: {
        "ui:widget": "updown",
        "ui:title": "Left - Knee Flexion",
        "classNames": "heart-total-chol-ratio",
        "ui:description": "Flexion = 135-145°",
        "ui:placeholder": "0"
    },
    left_hip_extension: {
        "ui:widget": "updown",
        "ui:title": "Left - Hip Extension",
        "classNames": "heart-total-chol-ratio",
        "ui:description": "Extension = 10-20°",
        "ui:placeholder": "0"
    },
    left_hip_flexion: {
        "ui:widget": "updown",
        "ui:title": "Left - Hip Flexion",
        "classNames": "heart-total-chol-ratio",
        "ui:description": "Hip flexion = 120 -130°",
        "ui:placeholder": "0"
    },
    left_hip_abduction: {
        "ui:widget": "updown",
        "ui:title": "Left - Hip Abduction",
        "classNames": "heart-total-chol-ratio",
        "ui:description": "Abduction = 45°",
        "ui:placeholder": "0"
    },
    left_hip_adduction: {
        "ui:widget": "updown",
        "ui:title": "Left - Hip Adduction",
        "classNames": "heart-total-chol-ratio",
        "ui:description": "Adduction = 30°",
        "ui:placeholder": "0"
    },
    left_glenohumeral_flexion: {
        "ui:widget": "updown",
        "ui:title": "Left - Glenohumeral Flexion",
        "classNames": "heart-total-chol-ratio",
        "ui:description": "Flexion = 170-180°",
        "ui:placeholder": "0"
    },
    left_glenohumeral_extension: {
        "ui:widget": "updown",
        "ui:title": "Left - Glenohumeral Extension",
        "classNames": "heart-total-chol-ratio",
        "ui:description": "Extension = 50 -60°",
        "ui:placeholder": "0"
    },
    left_glenohumeral_abduction: {
        "ui:widget": "updown",
        "ui:title": "Left - Glenohumeral Abduction",
        "classNames": "heart-total-chol-ratio",
        "ui:description": "Abduction = 170-180°",
        "ui:placeholder": "0"
    },
    left_glenohumeral_internal_rotation: {
        "ui:widget": "updown",
        "ui:title": "Left - Glenohumeral Internal Rotation",
        "classNames": "heart-total-chol-ratio",
        "ui:description": "Internal rotation = 80-90°",
        "ui:placeholder": "0"
    },
    left_glenohumeral_external_rotation: {
        "ui:widget": "updown",
        "ui:title": "Left - Glenohumeral External Rotation",
        "classNames": "heart-total-chol-ratio",
        "ui:description": "External rotation = 90-100°",
        "ui:placeholder": "0"
    },
    left_elbow_flexion: {
        "ui:widget": "updown",
        "ui:title": "Left - Elbow Flexion",
        "classNames": "heart-total-chol-ratio",
        "ui:description": "Flexion = 145-155°",
        "ui:placeholder": "0"
    },
    left_elbow_extension: {
        "ui:widget": "updown",
        "ui:title": "Left - Elbow Extension",
        "classNames": "heart-total-chol-ratio",
        "ui:description": "Extension = 0°",
        "ui:placeholder": "0"
    },
    left_wrist_flexion: {
        "ui:widget": "updown",
        "ui:title": "Left - Wrist Flexion",
        "classNames": "heart-total-chol-ratio",
        "ui:description": "Flexion = 80-90°",
        "ui:placeholder": "0"
    },
    left_wrist_extension: {
        "ui:widget": "updown",
        "ui:title": "Left - Wrist Extension",
        "classNames": "heart-total-chol-ratio",
        "ui:description": "Extension = 75-85°",
        "ui:placeholder": "0"
    },
    left_wrist_radial_deviation: {
        "ui:widget": "updown",
        "ui:title": "Left - Wrist Radial Deviation",
        "classNames": "heart-total-chol-ratio",
        "ui:description": "Radial deviation = 20°",
        "ui:placeholder": "0"
    },
    left_wrist_ulnar_deviation: {
        "ui:widget": "updown",
        "ui:title": "Left - Wrist Ulnar Deviation",
        "classNames": "heart-total-chol-ratio",
        "ui:description": "Ulnar deviation = 35°",
        "ui:placeholder": "0"
    },
    left_thumb_flexion: {
        "ui:widget": "updown",
        "ui:title": "Left - Thumb Flexion",
        "classNames": "heart-total-chol-ratio",
        "ui:description": "Flexion = 60-70°",
        "ui:placeholder": "0"
    },
    left_thumb_extension: {
        "ui:widget": "updown",
        "ui:title": "Left - Thumb Extension",
        "classNames": "heart-total-chol-ratio",
        "ui:description": "Extension = Only a trace amount of true CMC extension is permitted",
        "ui:placeholder": "0"
    },
    left_thumb_abduction: {
        "ui:widget": "updown",
        "ui:title": "Left - Thumb Abduction",
        "classNames": "heart-total-chol-ratio",
        "ui:description": "Abduction = 70-80°",
        "ui:placeholder": "0"
    },
    left_thumb_adduction: {
        "ui:widget": "updown",
        "ui:title": "Left - Thumb Adduction",
        "classNames": "heart-total-chol-ratio",
        "ui:description": "Adduction = True adduction is limited by the phalanx hitting the second metacarpal",
        "ui:placeholder": "0"
    }
}



// WEBPACK FOOTER //
// ./src/components/assessment/schema/JointROM.js